import { useBulkActionsDispatchContext } from '../contexts/bulkActionsContext';
export const useBulkActionsDispatch = () => {
  const dispatch = useBulkActionsDispatchContext();
  return dispatch;
};